import { TableCell } from "@mui/material"
import type { ReactElement } from "react"

interface ProductOriginGridHeaderProps {
  address: string | null
  testIdPrefix?: string
}

export const ProductOriginGridHeader = ({ address, testIdPrefix }: ProductOriginGridHeaderProps): ReactElement => {
  return address ? (
    <TableCell colSpan={3} data-testid={`${testIdPrefix}-address-label`}>
      Address
    </TableCell>
  ) : (
    <>
      <TableCell data-testid={`${testIdPrefix}-country-label`}>Country</TableCell>
      <TableCell data-testid={`${testIdPrefix}-region-label`}>State/Region</TableCell>
      <TableCell data-testid={`${testIdPrefix}-city-label`}>City</TableCell>
    </>
  )
}
